<template>
  
    <el-container>
     
      <el-main>
       <h1>在 markdown 文件中嵌入思维导图 </h1>

       <p>使用 <i>![[mindmap md]]</i> 语法嵌入思维导图，思维导图节点也支持该语法</p>

        <div>
           <img src="../assets/markmind/embed.gif" alt="" width="800">
       </div>

      </el-main>
    </el-container>
 
</template>

<script>
export default {
  name: 'EmbedPage',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}

a {
  color: #42b983;
}
</style>
